import React, { useEffect } from 'react';
import { EnterCredential } from 'new/elements/flows/EnterCredential';
import { FCFormPageType, useForm } from 'new/elements/Form/useForm';
import { FORM_TYPE_CREATE_CDC } from 'js/constants/formTypes';
import useCredentialsPage from 'new/components/flows/controller/useCredentialsPage';
import { loadDataCredentials, loadFullVendor } from 'js/actions';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import { useDispatch } from 'react-redux';
import useCDC from 'new/components/flows/types/cdc/CreateCDCFlow/CDCFlow/useCDC';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { GET_ALL_CREDENTIALS_REQUEST, GET_FULL_VENDOR_REQUEST } from 'js/constants/actionTypes';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';

export const EnterCredentialPage: FCFormPageType<any> = () => {
  const { credentialId, selectedConnection, selectedCredentialInfo } = useCDC();
  const { setLoaderMessages } = useForm();
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
  const {
    onSaveCredential,
    onEditCredential,
    onCredentialSelected,
    onCredentialInfoUpdated,
    onChangeTemplate,
    selectedTemplate,
  } = useCredentialsPage({
    useFormData: useCDC,
    formType: FORM_TYPE_CREATE_CDC,
  });

  useEffect(() => {
    setLoaderMessages({
      [GET_FULL_VENDOR_REQUEST]: 'Loading info',
    });
  }, []);

  useEffect(() => {
    if (selectedConnection) {
      dispatch(loadFullVendor(selectedConnection));
    }
  }, []);

  const loadCredentialNeeds = () => {
    dispatch(loadFullVendor(selectedConnection));
    dispatch(loadDataCredentials(ACLQueryModeTypes.MODE_COLLABORATOR.key));
  };

  const areCredentialsLoading = useIsLoading(GET_ALL_CREDENTIALS_REQUEST, GET_FULL_VENDOR_REQUEST);

  return (
    <EnterCredential
      reload={loadCredentialNeeds}
      areCredentialsLoading={areCredentialsLoading}
      credentialId={credentialId}
      onCredentialInfoUpdated={onCredentialInfoUpdated}
      onSaveCredential={onSaveCredential}
      onChangeTemplate={onChangeTemplate}
      onEditCredential={onEditCredential}
      selectedTemplate={selectedTemplate}
      selectedCredentialInfo={selectedCredentialInfo}
      onCredentialSelected={onCredentialSelected}
      connectionType={selectedConnection}
    />
  );
};

EnterCredentialPage.formConfig = {
  title: 'Authenticate',
};
